import { Controller } from '@hotwired/stimulus';

function getButton(el) {
  let currentElement = el.target || el;
  let level = 0;

  while (currentElement) {
    if (currentElement.nodeName === 'BUTTON') {
      return currentElement;
    }

    currentElement = currentElement.parentElement;
    level++;

    if (level > 10) {
      return null;
    }
  }

  return null;
}

export default class extends Controller {
  static targets = ['form'];

  initialize() {
    super.initialize();
    this.initialQuery = null;
  }

  connect() {
    this.initialQuery = this._collectQuery();

    this.formTarget.addEventListener('submit', this._onSubmit.bind(this));
    this.formTarget.addEventListener('custom-select:close', this._onSubmit.bind(this));
  }

  removeFilter(event) {
    const button = getButton(event.target);
    const field = button.getAttribute('data-field');
    const value = button.getAttribute('data-value');

    const query = this._collectQuery();
    if (query[field]) {
      query[field] = query[field].filter(v => v !== value);
    }

    this._doSubmit(query);
  }

  clearFilters() {
    this._doSubmit({});
  }

  _collectQuery() {
    const data = new FormData(this.formTarget);
    let query = {};

    for (const [key, value] of data.entries()) {
      let queryKey = key;

      if (key.substr(-2) === '[]') {
        queryKey = key.substr(0, key.length - 2);
      }

      if (!query[queryKey]) {
        query[queryKey] = [];
      }

      query[queryKey].push(value);
    }

    return query;
  }

  _onSubmit(event) {
    if (event.currentTarget?.nodeName === 'FORM') {
      event.preventDefault();
    }

    this._doSubmit(this._collectQuery());
  }

  _onChange(event) {
    this._onSubmit(event);
  }

  _doSubmit(query) {
    // if (!this._hasChanged(query)) {
    //   return;
    // }

    window.location.search = new URLSearchParams(this._flattenQuery(query)).toString();
  }

  _flattenQuery(query) {
    const flattenedQuery = Object.assign({}, query);

    for (const [key, value] of Object.entries(flattenedQuery)) {
      if (Array.isArray(value)) {
        if (value.length === 0) {
          delete flattenedQuery[key];
        } else {
          flattenedQuery[key] = value.join(',');
        }
      }
    }

    return flattenedQuery;
  }

  _hasChanged(query) {
    return JSON.stringify(query) !== JSON.stringify(this.initialQuery);
  }
}
